var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('error.lost')))]),_c('div',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('error.lost_message')))]),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(_vm._s(_vm.$t('label.return')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }